import ssmux from './emcc-source/ssmux-2.0.0.1';

export default ssmux;
